// Vendors
import React from 'react';
// Components
import { IconComponent, TooltipComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import { FINANCIAL_DATA_TOOLTIP_ASSET_CONSTANTS } from './constants/financial-data-tooltip.constants';
// Configurations
import { getTooltipConfiguration } from './configurations/financial-data-tooltip.configurations';
// Hooks
import { useFinancialDataTooltipHook } from './hooks/financial-data-tooltip.hook';
// Styles
import { RowLisTootltipLabelStyled } from './financial-data-tooltip.component.styled';

const FinancialDataTooltipComponent = (): React.JSX.Element => {
  const { formatMessage } = useFinancialDataTooltipHook();

  return (
    <RowLisTootltipLabelStyled>
      <TooltipComponent {...getTooltipConfiguration(formatMessage)}>
        <IconComponent {...FINANCIAL_DATA_TOOLTIP_ASSET_CONSTANTS} />
      </TooltipComponent>
    </RowLisTootltipLabelStyled>
  );
};

export { FinancialDataTooltipComponent };
